import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Tradfallning from "@/pages/Tradfallning";
import Beskarning from "@/pages/Beskarning";
import Stubbfrasning from "@/pages/Stubbfrasning";
import Bortforsling from "@/pages/Bortforsling";
import MarkAnlaggning from "@/pages/MarkAnlaggning";
import GronYteskotsel from "@/pages/GronYteskotsel";
import Snorojning from "@/pages/Snorojning";
import Motorsagskorkort from "@/pages/Motorsagskorkort";
import Kontakt from "@/pages/Kontakt";
import Referenser from "@/pages/Referenser";
import Blogg from "@/pages/Blogg";
import BloggPost from "@/pages/BloggPost";
import LocalAreaPage from "@/pages/LocalAreaPage";
import Integritetspolicy from "@/pages/Integritetspolicy";
import Cookiepolicy from "@/pages/Cookiepolicy";
import NotFound from "@/pages/NotFound";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminVerify from "@/pages/admin/AdminVerify";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminQuotes from "@/pages/admin/AdminQuotes";
import AdminBlog from "@/pages/admin/AdminBlog";
import AdminBlogEdit from "@/pages/admin/AdminBlogEdit";
import { GoogleReviewsProvider } from "@/lib/googleReviews";

export function AppContent() {
  return (
    <div className="App">
      <GoogleReviewsProvider>
        <Routes>
          {/* Admin routes (no public chrome) */}
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/verifiera" element={<AdminVerify />} />
          <Route element={<AdminLayout />}>
            <Route path="/admin/forfragningar" element={<AdminQuotes />} />
            <Route path="/admin/blogg" element={<AdminBlog />} />
            <Route path="/admin/blogg/nytt" element={<AdminBlogEdit />} />
            <Route path="/admin/blogg/:id" element={<AdminBlogEdit />} />
          </Route>

          {/* Public routes wrapped in main Layout */}
          <Route
            path="/*"
            element={
              <Layout>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/tradfallning" element={<Tradfallning />} />
                  <Route path="/beskarning" element={<Beskarning />} />
                  <Route path="/stubbfrasning" element={<Stubbfrasning />} />
                  <Route path="/bortforsling" element={<Bortforsling />} />
                  <Route
                    path="/mark-och-anlaggning"
                    element={<MarkAnlaggning />}
                  />
                  <Route
                    path="/gronyteskotsel-och-hackklippning"
                    element={<GronYteskotsel />}
                  />
                  <Route path="/snorojning" element={<Snorojning />} />
                  <Route
                    path="/motorsagskorkort"
                    element={<Motorsagskorkort />}
                  />
                  <Route path="/kontakt" element={<Kontakt />} />
                  <Route path="/referenser" element={<Referenser />} />
                  <Route path="/blogg" element={<Blogg />} />
                  <Route path="/blogg/:slug" element={<BloggPost />} />

                  {/* Local SEO pages */}
                  <Route
                    path="/tradfallning-bastad"
                    element={<LocalAreaPage areaKey="bastad" />}
                  />
                  <Route
                    path="/tradfallning-angelholm"
                    element={<LocalAreaPage areaKey="angelholm" />}
                  />
                  <Route
                    path="/tradfallning-orkelljunga"
                    element={<LocalAreaPage areaKey="orkelljunga" />}
                  />
                  <Route
                    path="/tradfallning-halmstad"
                    element={<LocalAreaPage areaKey="halmstad" />}
                  />

                  {/* Legal */}
                  <Route
                    path="/integritetspolicy"
                    element={<Integritetspolicy />}
                  />
                  <Route path="/cookiepolicy" element={<Cookiepolicy />} />

                  {/* Legacy URL redirects (client-side fallback; real 301s
                      live in /public/_redirects on the hosting platform). */}
                  <Route path="/home" element={<Navigate to="/" replace />} />
                  <Route
                    path="/tradfallning-1"
                    element={<Navigate to="/beskarning" replace />}
                  />
                  <Route
                    path="/tradfallning-2"
                    element={<Navigate to="/stubbfrasning" replace />}
                  />
                  <Route
                    path="/tradfallning-3"
                    element={<Navigate to="/mark-och-anlaggning" replace />}
                  />
                  <Route
                    path="/snorojning-1"
                    element={<Navigate to="/snorojning" replace />}
                  />
                  <Route
                    path="/snorojning-2"
                    element={<Navigate to="/snorojning" replace />}
                  />
                  <Route
                    path="/snorojning-3"
                    element={<Navigate to="/snorojning" replace />}
                  />
                  <Route path="/read-me" element={<Navigate to="/" replace />} />
                  <Route path="/new-page" element={<Navigate to="/" replace />} />
                  <Route path="/store" element={<Navigate to="/" replace />} />

                  <Route path="*" element={<NotFound />} />
                </Routes>
              </Layout>
            }
          />
        </Routes>
      </GoogleReviewsProvider>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
